"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceEventUpdate = exports.ServiceEventTemplate = exports.ServiceEventCreate = exports.ServiceEvent = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const nullable_1 = require("../common/nullable");
const ServiceLineItemType_1 = require("./ServiceLineItemType");
const common_types_1 = require("./common-types");
exports.ServiceEvent = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    description: typebox_1.Type.String(),
    dateExpected: typebox_1.Type.String(),
    dateExecuted: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: common_types_1.ServiceEventStatus,
    eventType: common_types_1.ServiceEventType,
    lineItemType: ServiceLineItemType_1.ServiceLineItemType,
    serviceOrderID: typebox_1.Type.String({ format: 'uuid' }),
    invoiceGroupingID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    basePrice: typebox_1.Type.Number(), // us to customer
    baseCost: typebox_1.Type.Number(), // vendor to us
    unitPrice: typebox_1.Type.Number(), // us to customer
    unitCost: typebox_1.Type.Number(), // vendor to us
    unitType: ServiceLineItemType_1.ServiceLineItemUnitType,
    priceQuantity: typebox_1.Type.Number(),
    costQuantity: typebox_1.Type.Number(),
    taxable: typebox_1.Type.Boolean(),
    metadata: common_1.MetaData,
});
exports.ServiceEventCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ServiceEvent, ['id', 'dateExecuted', 'lineItemType', 'serviceOrderID', 'metadata', 'invoiceGroupingID']),
    typebox_1.Type.Object({
        lineItemTypeID: typebox_1.Type.String({ format: 'uuid' }),
        invoiceGroupingID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'uuid' }))),
    }),
]);
exports.ServiceEventTemplate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ServiceEventCreate, ['dateExpected']),
    typebox_1.Type.Partial(typebox_1.Type.Object({
        applyToFirstInvoice: typebox_1.Type.Boolean(),
        applyToLastInvoice: typebox_1.Type.Boolean(),
        applyWhenStatusIs: common_types_1.ServiceOrderStatus,
    })),
]);
exports.ServiceEventUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ServiceEvent, ['id', 'serviceOrderID', 'lineItemType', 'invoiceGroupingID', 'metadata']),
    typebox_1.Type.Object({ lineItemTypeID: typebox_1.Type.String({ format: 'uuid' }) }),
]));
//# sourceMappingURL=ServiceEvent.js.map